// The solar radiation reading is an unsigned 12-bit ADC value with an offset. The offset is first subtracted from the ADC value, the offset ADC value is converted to volts, and finally to solar irradiance in watts per square meter (W/m2). The ConversionFormulaOffset parameter contains the offset and the ConversionFormulaScale parameter converts volts to solar irradiance. Convert the 12-bit ADC value ($rdg in code below) to solar irradiance ($sol in code below) using the following algorithm:

/*
$sol = 0.0;

if ( $rdg == 0xFFF ) {
  $sol = null; // display reading as “invalid”
} else {
  $scale = (float)$ConversionFormulaScale;
  $offset = (float)$ConversionFormulaOffset;

  $volt = (float)$rdg - $offset;

  $volt = ($volt * 2.0 / 4095.0);
  if ( ( $volt > 0.0 ) && ( $scale > 0.0 ) ) {
    $sol = ($volt * 1000000.0) / $scale;
  }
}
*/

// To calibrate the sensor, replace the sensor input with a connection to ground, read the ADC value and use that value as the new offset. Store the new offset in the ConversionFormulaOffset parameter.

export function solarRadiation(
  reading: number,
  scale: number,
  offset: number,
  frequency: number
): number {
  var voltage = reading - offset
  voltage = (voltage * 2.0) / 4095.0

  if (voltage > 0.0 && scale > 0.0) {
    return (voltage * 1000000.0) / scale
  }
  return 0
}
